import { useMediaQuery } from 'react-responsive';

const breakpoints = {
  mobileS: '(max-width: 360px)',
  mobileM: '(max-width: 375px)',
  mobileL: '(max-width: 414px)',
  tablet: '(max-width: 768px)',
  laptop: '(max-width: 1024px)',
  laptopL: '(max-width: 1440px)',
  desktop: '(max-width: 1920px)',
  desktopL: '(max-width: 2560px)',
};

export function useBreakpoints() {
  const isMobileS = useMediaQuery({ query: breakpoints.mobileS });
  const isMobileM = useMediaQuery({ query: breakpoints.mobileM });
  const isMobileL = useMediaQuery({ query: breakpoints.mobileL });
  const isTablet = useMediaQuery({ query: breakpoints.tablet });
  const isLaptop = useMediaQuery({ query: breakpoints.laptop });
  const isLaptopL = useMediaQuery({ query: breakpoints.laptopL });
  const isDesktop = useMediaQuery({ query: breakpoints.desktop });
  const isDesktopL = useMediaQuery({ query: breakpoints.desktopL });

  return {
    isMobileS,
    isMobileM,
    isMobileL,
    isTablet,
    isLaptop,
    isLaptopL,
    isDesktop,
    isDesktopL,
  };
}
